<cei-app-template
  [showSidenav]="true"
  [autoHideMenu]="false"
  [sidenavWidth]="68"
  [footerPlacement]="CEI_APP_TEMPLATE_FOOTER_PLACEMENT_CONTENT"
  [contentInnerPadding]="'0'"
  [customUserActions]="true"
>
  <div
    ngProjectAs="[user-actions]"
    user-actions
    class="portal-layout__user-actions"
    (click)="$event.stopPropagation()"
  >
    <cei-toolbar-user-area
      [userName]="userLogin()"
      [fotoSourceUrl]="fotoToolbarUrl()"
      [fallbackToSessionProfile]="false"
      [ariaExpanded]="menuAberto()"
      avatarLabel="Abrir menu de dados pessoais"
      (avatarClick)="togglePersonalMenu($event)"
    >
      <cei-personal-data-menu
        [open]="menuAberto()"
        [items]="personalMenuItems()"
        [autoLoad]="false"
        (itemClick)="onPersonalMenuItemClick($event)"
      ></cei-personal-data-menu>
    </cei-toolbar-user-area>
  </div>

  <cei-floating-dock-sidenav
    sidenav
    [userId]="userId()"
    [exibirRotuloNoHover]="true"
    [expandirItemNoHover]="true"
    [exibirDicaNoHover]="true"
    [expandirItemNoToqueMobile]="true"
  ></cei-floating-dock-sidenav>

  <router-outlet />
</cei-app-template>
